import { getSvgIconName, SvgIcon } from '@bob/library'
import { Asset } from '@websrc/App/Components/Asset/Asset'
import { Button, BUTTON_WIDTH } from '@websrc/App/Components/Button/Button'
import { mapSelectorItem } from '@websrc/DataMappers/mapSelector'
import clsx from 'clsx'
import { border, breakpoints, styles, typography } from 'leds'
import React, { ComponentPropsWithoutRef } from 'react'

export type SelectorItemProps = Omit<ComponentPropsWithoutRef<'div'>, 'content'> & {
  content: ReturnType<typeof mapSelectorItem>
}

export const SelectorItem: React.FC<SelectorItemProps> = ({
  content: { image, cta, icon, title },
  ...divProps
}) => (
  <div
    {...divProps}
    className={clsx(
      border({ color: 'grey4', rounded: 'small' }),
      styles({
        padding: 10,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
      }),
      divProps.className
    )}
  >
    <span>
      <p
        className={clsx(
          typography({ size: 'sm' }),
          styles({ display: 'flex', alignItems: 'center' })
        )}
      >
        {icon.icon && (
          <SvgIcon
            className={styles({ marginRight: 5 })}
            color={'black'}
            name={getSvgIconName(icon.icon)}
            size={18}
            title={icon.label || title}
          />
        )}
        {icon.label}
      </p>
      <p
        className={clsx(
          typography({ size: 'md', weight: 'bold' }),
          styles({ marginBottom: 10, flexGrow: 1 })
        )}
      >
        {title}
      </p>
    </span>
    {image && (
      <Asset
        dataTestId={`image-${image.title}`}
        fit={'bounds'}
        sizes={`(max-width: ${breakpoints.m}px) 90vw, 550px`}
        srcSetWidths={[400, 600, 800]}
        thumbnail={image}
      />
    )}
    <div className={styles({ marginTop: 10 })}>
      <Button
        color={'blue'}
        colorMode={'light'}
        download={cta?.file?.url ? true : false}
        href={cta?.url ? cta.url : cta?.file?.url}
        iconName={'ARROW_RIGHT'}
        iconPosition={'left'}
        size={'medium'}
        target={cta?.file?.url ? '_blank' : cta?.newTab ? '_blank' : '_self'}
        text={cta?.text}
        type={'tertiary'}
        width={BUTTON_WIDTH.Full}
      />
    </div>
  </div>
)
